import { getQueryStringFromObject } from './common.service';
import api from './axios.service';
const axios = api;

const getPoints = async (query = {}) => {
    try {
        let queryString = await getQueryStringFromObject(query);
        if (queryString) {
            queryString = '?' + queryString;
        } else {
            queryString = '';
        }
        let response = await axios.get(`/points${queryString}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const resetPoints = async () => {
    try {
        let response = await axios.post(`/points/reset`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const exportSongPerformance = async () => {
    try {
        let response = await axios.get(`/points/song_performance/export`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const exportGroupPerformance = async () => {
    try {
        let response = await axios.get(`/points/group_performance/export`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

export {
    getPoints,
    resetPoints,
    exportSongPerformance,
    exportGroupPerformance,
};
